import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ScheduleRow, { scheduleDayShape } from './schedule_row';
import geocode from '../../app/geocode';
import classnames from '../../utils/classnames';

const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export default class AddressForm extends Component {
  componentDidMount() {
    this.setState({ lat: this.props.address.lat, lng: this.props.address.lng });
  }

  componentWillReceiveProps(nextProps) {
    const coordinateAttributes = ['lat', 'lng'];
    if (!_.isEqual(_.pick(this.props.address, coordinateAttributes), _.pick(nextProps.address, coordinateAttributes))) {
      this.setState({ lat: nextProps.lat, lng: nextProps.lng });
    }
  }

  name(name) {
    return `student[addresses_attributes][${this.props.index}]${name}`;
  }

  schedule() {
    const { address: { schedule } } = this.props;
    if (!schedule) { return ''; }
    return JSON.stringify(schedule);
  }

  formGroup(key) {
    const { address } = this.props;
    const { errors } = address;
    const hasError = errors && !_.isEmpty(errors[key]);
    return (
      <div className={classnames('form-group', { 'has-error': hasError })}>
        <input type="text" className="form-control" name={this.name(`[${key}]`)} defaultValue={address[key]} ref={this[_.camelCase(`on_${key}_ref`)]} onChange={this.onAddressChange} />
        {hasError ? <span className="help-block">{errors[key][0]}</span> : null}
      </div>
    );
  }

  coordinates() {
    const { address } = this.props;
    const { errors } = address;
    const hasError = errors && (!_.isEmpty(address.errors.lat) || !_.isEmpty(address.errors.lng));
    return (
      <div className={classnames('form-group', { 'has-error': hasError })}>
        <input type="hidden" name={this.name('[lat]')} value={(this.state && this.state.lat) || ''} />
        <input type="hidden" name={this.name('[lng]')} value={(this.state && this.state.lng) || ''} />
        <input type="text" className="form-control" readOnly value={this.state ? _([this.state.lat, this.state.lng]).compact().join(', ') : ''} />
        {hasError ? <span className="help-block">{errors.lat[0] || errors.lng[0]}</span> : null}
      </div>
    );
  }

  onRef(key, ref) { this[key] = ref; }

  onScheduleSelect = (day, time, value) => {
    const { onScheduleSelect, index, address } = this.props;
    onScheduleSelect(address, index, day, time, value);
  }

  onActionClick = () => {
    this.props.onActionClick(this.props.action, this.props.index);
  }

  onAddressChange = () => {
    const { streetInput, npaInput, cityInput } = this;
    geocode(..._.map([streetInput, npaInput, cityInput], 'value'))
      .then(location => this.setState(location))
      .catchReturn();

    if (this.props.index !== 0) { return; }
    _.forEach(['street', 'npa', 'city'], (key) => {
      $(`#student_address_${key}_preview`).text(this[`${key}Input`].value);
    })
  }

  onStreetRef = this.onRef.bind(this, 'streetInput')
  onNpaRef = this.onRef.bind(this, 'npaInput')
  onCityRef = this.onRef.bind(this, 'cityInput')

  render() {
    const { address, action } = this.props;
    return (
      <div className="row-item">
        {address.id ? <input type="hidden" name={this.name('[id]')} value={address.id} />: null}
        <div className="row">
          <div className="col-md-11">
            <div className="row">
              <div className="col-md-4">
                {this.formGroup('street')}
              </div>
              <div className="col-md-2">
                {this.formGroup('npa')}
              </div>
              <div className="col-md-3">
                {this.formGroup('city')}
              </div>
              <div className="col-md-3">
                {this.coordinates()}
              </div>
            </div>
            <div className="row weekdays">
              {_.map(days, day => (
                <ScheduleRow key={day} schedule={_.get(address, ['schedule', day])} day={day} onSelect={this.onScheduleSelect} />
              ))}
              <input type="hidden" name={this.name('[schedule_as_json]')} value={this.schedule()} />
            </div>
          </div>
          <div className="col-md-1">
            <div className="form-group">
              <div className="row-actions">
                <a className="btn-row-actions" tabIndex={0} role="button" onClick={this.onActionClick}>
                  {action === 'add' ? <i className="fa fa-plus"></i> : <i className="fa fa-trash"></i> }
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const scheduleShape = PropTypes.shape(
  _.reduce(days, (shape, day) => _.extend(shape, { [day]: scheduleDayShape }), {})
);

export const addressShape = PropTypes.shape({
  id: PropTypes.number,
  street: PropTypes.string,
  city: PropTypes.string,
  npa: PropTypes.string,
  schedule: scheduleShape
});

AddressForm.propTypes = {
  address: addressShape,
  index: PropTypes.number.isRequired,
  action: PropTypes.oneOf(['add', 'delete']).isRequired,
  onActionClick: PropTypes.func.isRequired,
  onScheduleSelect: PropTypes.func.isRequired,
}
